export default function useMethods(
    salon: Model.Response<Admin.Resources.User>
): Admin.Models.User.Methods {
    return { }
}